import { PreferredIpi } from 'types/ipi.types';
import { PreferredIpn } from 'types/ipn.types';
import { Profile, Representative } from 'types/profile';

export const getRepresentativesDate = (
  representatives: Representative[] = []
) =>
  representatives?.map(({ firstName, lastName, ...representative }) => ({
    ...representative,
    name: [firstName, lastName].join(' '),
  })) || [];

const getIPIValue = (preferredIpi?: PreferredIpi) => ({
  primary: preferredIpi?.number,
  secondary: preferredIpi?.prSocietyAffiliation?.acronym,
});

const getIPNValue = (preferredIpn?: PreferredIpn) => ({
  primary: preferredIpn?.number,
  secondary: preferredIpn?.cmoSocietyAffiliation?.acronym,
});

interface ProfileData {
  key: string;
  label: string;
  value: {
    primary?: string | number;
    secondary?: string;
  };
}

export const getProfileData = (
  isLoading: boolean,
  profile?: Profile
): ProfileData[] =>
  [
    {
      key: 'artistName',
      label: 'Artist name',
      value: {
        primary: profile?.artistName,
      },
    },
    {
      key: 'email',
      label: 'Email',
      value: {
        primary: profile?.email,
      },
    },
    {
      key: 'ipi',
      label: 'IPI',
      value: getIPIValue(profile?.preferredIpi),
    },
    {
      key: 'ipn',
      label: 'IPN',
      value: getIPNValue(profile?.preferredIpn),
    },
    {
      key: 'isni',
      label: 'ISNI',
      value: {
        primary: profile?.preferredIsni?.number,
      },
    },
  ].filter(({ value }) => isLoading || value.primary !== undefined);
